import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {AdditionalGroupProps} from '../types';
import additionalGroupsKeys from '../util/additional-groups-keys';

export interface EditAdditionalGroupProps
  extends Omit<AdditionalGroupProps, 'id'> {}

const useEditAdditionalGroup = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: AdditionalGroupProps) => {
    update(additionalGroupsKeys.list(), data);
    setData(additionalGroupsKeys.details(id), data);
  };

  return useApiMutation<EditAdditionalGroupProps>({
    url: `/additional-groups/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar grupo de adicional',
    successTitle: 'Editar grupo de adicional',
    successMessage: 'Grupo de adicional atualizado com sucesso',
    onSuccess,
  });
};

export default useEditAdditionalGroup;
